const { either, isEmpty, isNil, pipe, prop } = require("ramda");

module.exports = pipe(prop("rows"), either(isNil, isEmpty));
